import { Component, Input, Pipe, PipeTransform, EventEmitter, Output, OnDestroy, ViewChild } from '@angular/core';
import {MatDialog} from '@angular/material';

import {SlideshowService} from '../../slideshow.service';
import {ImagesService} from '../../../shared/images.service';
import {ImageDetailsDialog} from '../../images/image-details-dialog.component';

@Pipe({name: 'tempImages'})
export class TempImagesPipe implements PipeTransform {
    transform(list, groupIds): string {
        if( !list || !groupIds ) {
            return list;
        }
        return list.filter(item => {
            return groupIds.indexOf(item.groupId) !== -1;
        });
    }
}
@Component({
    selector: 'image-component',
    templateUrl: 'image.component.html'
})
export class ImageComponent implements OnDestroy {
    imageUploadSubscription;
    loading = false;

    private _canEdit = false;
    private _images = [];
    private _imagesMobile = [];
    private _single = false;
    private _slideIndex = 0;
    
    @Input('canEdit')
    set canEdit(canEdit) {
        this._canEdit = canEdit;
    }
    get canEdit() {
        return this._canEdit;
    }
    @Input('images')
    set images(images) {
        this._images = images;
    }
    get images() {
        return this._images;
    }
    @Input('imagesMobile')
    set imagesMobile(imagesMobile) {
        this._imagesMobile = imagesMobile;
    }
    get imagesMobile() {
        return this._imagesMobile;
    }
    @Input('single')
    set single(single) {
        this._single = single;
    }
    get single() {
        return this._single;
    }
    @Input('slideIndex')
    set slideIndex(slideIndex) {
        this._slideIndex = slideIndex;
    }
    get slideIndex() {
        return this._slideIndex;
    }
    
    @Output() slideImagesChange = new EventEmitter();

    @ViewChild('imageInput') imageInput;
    @ViewChild('imageInputMobile') imageInputMobile;

    constructor(
        private dialog: MatDialog,
        private imagesService: ImagesService, 
        private slideshow: SlideshowService
    ) {}
    insertImage(image, mobile) {
        let list = this.images;
        if( mobile ) {
            list = this.imagesMobile;
        } else {
            const mobileList = this.imagesMobile;
            let i = mobileList.length;
            while(i--) {
                if( mobileList[i].id == image.id ) {
                    this.imagesMobile.splice(i, 1);
                }
            }
        }
        if( this.single || mobile ) {
            list[0] = image;
        } else {
            list.push(image);
        }
        this.slideImagesChange.emit({
            mobile: mobile,
            images: mobile ? this.imagesMobile : this.images
        });
    }
    maybeInsertImage(image, mobile) {
        if( this.mustAddDetails(image) ) {
            this.popImageDialog(image, true, mobile);
        } else {
            this.insertImage(image, mobile);
        }
    }
    listHasImage(id) {
        const list = this.images;
        for(var i = 0; i < list.length; i++) {
            const item = list[i];
            if( id == item.id ) {
                return true;
            }
        }
        return false;
    }
    drop(e, mobile) {
        if( !this.canEdit ) {
            return;
        }

        if( !e.isExternal ) {
            const imgIndex = e.data;
            let img = this.imagesService.images[imgIndex];
            if( !mobile && this.listHasImage(img.id) ) {
                return;
            }
            this.maybeInsertImage(img, mobile);
            return;
        }

        this.handleImageUpload(e.event.dataTransfer.files, mobile);
    }
    handleImageUpload(files, mobile) {
        if( !this.canEdit ) {
            return;
        }
        let count = files.length;
        this.imageUploadSubscription = this.imagesService.imageUploaded.subscribe(img => {
            count -= 1;
            this.maybeInsertImage(img, mobile);
            if( count == 0 ) {
                this.imageUploadSubscription.unsubscribe();
            }
        });
        this.imagesService.handleDropFiles(files, this.slideshow.assignment, true);
    }
    mustAddDetails(img) {
        return !img.caption || !img.title || !img.alt;
    }
    openFiles(mobile) {
        if( !this.canEdit ) {
            return;
        }
        if( mobile ) {
            this.imageInputMobile.nativeElement.click();
        } else {
            this.imageInput.nativeElement.click();
        }
    }
    popImageDialog(image, addToSlide, mobile) {
        const dialog = this.dialog.open(ImageDetailsDialog, {
            data: {
                image: image,
                canEdit: this.canEdit,
                mobileOnly: mobile
            }
        });
        dialog.afterClosed().subscribe(img => {
            if( img && addToSlide ) {
                this.insertImage(img, mobile);
            }
        });
    }
    removeAttachment(images, i) {
        images.splice(i, 1);
    }
    getDimensions(image, mobile) {
        let useImage = image.sizes.full;
        if( mobile ) {
            useImage = image.sizes.mobile ? image.sizes.mobile : image.sizes.medium;
        }
        if( this.slideshow.quiz ) {
            useImage = image.sizes.quiz;
        }
        let width = useImage.width;
        let height = useImage.height;
        if( useImage.crop ) {
            width = useImage.crop.width;
            height = useImage.crop.height;
        }
        return width + 'x' + height;
    }
    getSize(image) {
        return image.sizes.mobile ? 'mobile' : 'medium';
    }
    getSrc(image, index, mobile) {
        if( index == 0 ) {
            if( mobile ) {
                return image.sizes.mobile ? image.sizes.mobile.urlWithParams : image.sizes.medium.urlWithParams
            }
            return this.slideshow.quiz ? image.sizes.quiz.urlWithParams : image.sizes.full.urlWithParams;
        }
        return image.sizes.thumbnail.urlWithParams;
    }
    showPlaceholder() {
        if( this.images.length > 0 && (this.canEdit || typeof this.images[0].sizes.mobile !== 'undefined') ) {
            return false;
        }
        return true;
    }
    ngOnDestroy() {
        if( this.imageUploadSubscription ) {
            this.imageUploadSubscription.unsubscribe();
        }
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/slideshow/slide/parts/image.component.ts